define('fukit/roles',['require','exports','module','underscore','./config'],function(require, exports, module) {
  //prettier-ignore
  var _         = require('underscore'),
      appConfig = require('./config'),
      Roles     = {};

  //prettier-ignore
  Roles.generateRoles = function(config) {
    var RoleKeyPrefixes        = config.get('ROLE_KEY_PREFIXES'),
        RoleValuePrefixes      = config.get('ROLE_VALUE_PREFIXES'),
        RolePermissionSuffixes = config.get('ROLE_PERMISSION_SUFFIXES'),
        GlobalAccessRoles      = config.get('global.access.roles');

    _.each(RoleKeyPrefixes, function(keyPrefix, index) {
      _.each(RolePermissionSuffixes, function(permissionSuffix) {
        //prettier-ignore
        var roleKey   = keyPrefix + permissionSuffix,
            roleValue = RoleValuePrefixes[index] + permissionSuffix;

        Roles[roleKey] = roleValue;
      });
    });

    if (GlobalAccessRoles) {
      Roles.GLOBALACCESSROLES = GlobalAccessRoles;
    }
  }

  Roles.generateRoles(appConfig);

  module.exports = Roles;
});

